<template>
    <div style="height: 100%;">
        <router-view/>
        <van-tabbar v-model="active" :placeholder="true" :safe-area-inset-bottom="true">
            <van-tabbar-item replace to="/storebeautyhead" icon="bar-chart-o">
                <span>美容员工</span>
            </van-tabbar-item>
            <van-tabbar-item replace to="/sendcard" icon="manager-o">
                <span>分配负责人</span>
            </van-tabbar-item>
        </van-tabbar>
    </div>
    </template>
    <script>
        export default {
            data(){
                return {
                    active:0,
                }
            }
        }
    </script>


// WEBPACK FOOTER //
// src/page/beauty/beautytabbar.vue